export default __webpack_public_path__ + "static/media/profile-icon2.5ffa36c0.jpg";